import React, { useState } from "react";
import "./Home.css";
import serviceimage1 from "../assets/images/people.webp";
import serviceimage2 from "../assets/images/bulbimage.webp";
import serviceimage5 from "../assets/images/About.webp";
import serviceimage6 from "../assets/images/peoples.webp";
import serviceAI from "../assets/images/Frame 3.jpg";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap CSS is imported
import ContactForm from "../component/ContactForm";
import LLMVideo from "../assets/videos/sst_ad.mp4";
import LLMVideo1 from "../assets/videos/LlmInsight.mp4";
import LLMInsightLogo from "../assets/AI images/llminsight.png";
import Chat_llminsight from "../assets/AI images/Single Chat Window.png";
import Cost_llminsight from "../assets/AI images/Cost Monitoring System.png";
import Security_llminsight from "../assets/AI images/Security & Compliance 2 1.png";
import Role_llminsight from "../assets/AI images/Advanced Insights.png";
import Logs_llminsight from "../assets/AI images/Logs Feature.png";
import LLMVideo2 from "../assets/videos/LLMInsightshortintroduction.mp4";
import LLMVideo3 from "../assets/videos/SSTAIFrameworkArchitecture.mp4";
import VideoThumbnail from "../assets/AI images/thumbnail5.png";
import VideoThumbnail1 from "../assets/AI images/LLM Insight Overview Thumbnail.jpg";
import VideoThumbnail2 from "../assets/AI images/LLM Insight Introduction Thumbnail.png";
import VideoThumbnail3 from "../assets/AI images/SST AI Thumbnail.jpg";
import LLMInsight from "../assets/AI images/Frame 2611730 2.png";
import LLMOverview from "../assets/AI images/Carousel 1.jpg";
import LLMBenefits from "../assets/AI images/Carousel 2.jpg";
import LLMSolution from "../assets/AI images/Carousel 3.jpg";
import LLMAgents from "../assets/AI images/Carousel 4.jpg";
import AzureLogo from "../assets/AI images/Azure.png";
import AWSLogo from "../assets/AI images/aws.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import QuickLinks from "../component/QuickLinks";
import Benefits from "../component/Benefits";
const Home = () => {
  const features = [
    Cost_llminsight,
    Chat_llminsight,
    ,
    Logs_llminsight,
    Role_llminsight,
    Security_llminsight,
  ];

  const videoPlaylist = [
    {
      id: 1,
      src: LLMVideo,
      title: "LLM Insight Advertisment",
      thumbnail: VideoThumbnail,
      type: "local",
    },
    {
      id: 2,
      src: LLMVideo1,
      title: "LLM Insight Overview",
      thumbnail: VideoThumbnail1,
      type: "local",
    },
    {
      id: 3,
      src: LLMVideo2,
      title: "LLM Insight Introduction",
      thumbnail: VideoThumbnail2,
      type: "local",
    },
    {
      id: 4,
      src: LLMVideo3,
      title: "SST AI Framework",
      thumbnail: VideoThumbnail3,
      type: "local",
    },
    {
      id: 5,
      title: "YouTube Demo",
      src: "https://www.youtube.com/embed/7Um76Nved4M", // Convert to embed URL
      thumbnail: "https://img.youtube.com/vi/7Um76Nved4M/0.jpg", // You'll need a thumbnail image
      type: "youtube",
    },
    {
      id: 6,
      title: "YouTube Demo",
      src: "https://www.youtube.com/embed/iORGoFlhl8Y", // Convert to embed URL
      thumbnail: "https://img.youtube.com/vi/iORGoFlhl8Y/hqdefault.jpg", // You'll need a thumbnail image
      type: "youtube",
    },
    {
      id: 7,
      title: "YouTube Demo",
      src: "https://www.youtube.com/embed/Hx5Jowbdt8M", // Convert to embed URL
      thumbnail: "https://img.youtube.com/vi/Hx5Jowbdt8M/hqdefault.jpg", // You'll need a thumbnail image
      type: "youtube",
    },
    {
      id: 8,
      title: "YouTube Demo",
      src: "https://www.youtube.com/embed/7w_Jr8w_zH8", // Convert to embed URL
      thumbnail: "https://img.youtube.com/vi/7w_Jr8w_zH8/hqdefault.jpg", // You'll need a thumbnail image
      type: "youtube",
    },
    {
      id: 9,
      title: "YouTube Demo",
      src: "https://www.youtube.com/embed/5SeQ6yPdn3M", // Convert to embed URL
      thumbnail: "https://img.youtube.com/vi/5SeQ6yPdn3M/hqdefault.jpg", // You'll need a thumbnail image
      type: "youtube",
    },
    {
      id: 10,
      title: "YouTube Demo",
      src: "https://www.youtube.com/embed/fC6Qdom7BBQ", // Convert to embed URL
      thumbnail: "https://img.youtube.com/vi/fC6Qdom7BBQ/hqdefault.jpg", // You'll need a thumbnail image
      type: "youtube",
    },
  ];

  const [currentVideo, setCurrentVideo] = useState(videoPlaylist[0]);

  const renderVideoPlayer = () => {
    if (currentVideo.type === "youtube") {
      return (
        <iframe
          width="100%"
          height="100%"
          src={currentVideo.src}
          title={currentVideo.title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ borderRadius: "4px", padding: "4px" }}
        ></iframe>
      );
    } else {
      return (
        <video
          controls
          autoPlay
          muted
          key={currentVideo.src}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            borderRadius: "4px",
            padding: "4px",
          }}
        >
          <source src={currentVideo.src} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    }
  };

  return (
    <>
      <div className="container">
        <div className="w-100 py-2">
          <Carousel>
            <Carousel.Item>
              <img
                className="d-block w-100 "
                src={LLMInsight}
                alt="LLMInsight"
              />
              <Carousel.Caption></Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100 "
                src={LLMOverview}
                alt="LLMOverview"
              />
              <Carousel.Caption></Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100 "
                src={LLMBenefits}
                alt="LLMBenefits"
              />
              <Carousel.Caption></Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100 "
                src={LLMSolution}
                alt="LLMSolution"
              />
              <Carousel.Caption></Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img className="d-block w-100 " src={LLMAgents} alt="LLMAgents" />
              <Carousel.Caption></Carousel.Caption>
            </Carousel.Item>
          </Carousel>
          <div>
            <h2 className="text">
              TRANSFORMING BUSINESSES WITH{" "}
              <span className="span-text">LLM-POWERED INNOVATION</span>
            </h2>
            <p className="p-text">
              Harness the power of Artificial Intelligence to drive efficiency,
              automation, and intelligent decision-making.
              <br />
              From AI-driven analytics and machine learning solutions to
              intelligent automation and next-gen AI applications, we help
              businesses unlock their full potential with cutting-edge
              technology.
            </p>
            {/* <div className="container my-4">
              <div className="row"> */}
            <div className="col-12 text-center">
              <h3 className="text">
                WE ARE ISV PARTNERS OF{" "}
                <span className="span-text">AZURE AND AWS</span>{" "}
              </h3>
              <p>
                Our company partners with industry leaders Azure and AWS to
                deliver scalable, secure, and efficient cloud solutions tailored
                to your needs.
              </p>
              <div className="vendor-logos">
                <img
                  src={AzureLogo}
                  alt="Azure Logo"
                  className="vendor-logo"
                  style={{ maxWidth: "150px", marginRight: "30px" }}
                />
                <img
                  src={AWSLogo}
                  alt="AWS Logo"
                  className="vendor-logo"
                  style={{ maxWidth: "150px" }}
                />
              </div>
            </div>
            {/* </div>
            </div> */}

            {/* Videos Section */}

            <div className="row my-4">
              <div className="col-md-8">
                {renderVideoPlayer()}
                {/* <video
                  className="w-100"
                  controls
                  autoPlay
                  muted
                  key={currentVideo}
                >
                  <source src={currentVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video> */}
              </div>
              <div className="col-md-4  flex-column align-items-center">
                <h5>Watch More</h5>
                <div className="watch-more-container">
                  {videoPlaylist.map((video, index) => (
                    <div
                      key={index}
                      className={`video-thumbnail my-2 p-1 border rounded d-flex align-items-center ${
                        currentVideo.id === video.id ? "active-thumbnail" : ""
                      }`}
                      onClick={() => setCurrentVideo(video)}
                      style={{
                        cursor: "pointer",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        textAlign: "center",
                        position: "relative",
                      }}
                    >
                      <img
                        src={video.thumbnail}
                        alt={video.title}
                        style={{
                          width: "80%",
                          height: "auto",
                          maxHeight: "100px",
                          objectFit: "cover",
                          borderRadius: 4,
                        }}
                      />
                      {currentVideo.id === video.id && (
                        <div className="play-icon active">
                          <FontAwesomeIcon icon={faPlay} />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* <div className="row my-4">
              <div className="col-12 col-lg-4 order-lg-2 d-flex flex-column align-items-center">
                <h5>Watch More</h5>
                <div
                  className="watch-more-container d-flex flex-lg-column flex-row overflow-auto"
                  style={{
                    width: "100%",
                    gap: "10px", 
                    whiteSpace: "nowrap",
                    paddingBottom: "10px", 
                  }}
                >
                  {videoPlaylist.map((video, index) => (
                    <div
                      key={index}
                      className={`video-thumbnail p-2 border rounded d-flex align-items-center ${
                        currentVideo === video.src ? "active-thumbnail" : ""
                      }`}
                      onClick={() => setCurrentVideo(video.src)}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        textAlign: "center",
                        position: "relative",
                        minWidth: "130px", 
                        height: "130px",
                        marginBottom: "10px", 
                      }}
                    >
                      <img
                        src={video.thumbnail}
                        alt={video.title}
                        style={{
                          width: "auto",
                          height: "80px", 
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                      />
                      {currentVideo === video.src && (
                        <div className="play-icon active">
                          <FontAwesomeIcon icon={faPlay} />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-12 col-lg-8 order-lg-1">
                <video
                  className="w-100"
                  controls
                  autoPlay
                  muted
                  key={currentVideo}
                >
                  <source src={currentVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div> */}

            <div className="row">
              {/* Heading Card */}
              <div className="col-12">
                <div className="card llm-card">
                  <h3 className="card-title">
                    LLMInsights: Revolutionizing LLM Governance
                  </h3>
                  <p className="card-text">
                    <strong>LLMInsights</strong> is a cutting-edge AI governance
                    and cost management solution built on the{" "}
                    <strong>SSTAI Framework</strong>, designed to provide
                    <strong>
                      {" "}
                      visibility, accountability, and control
                    </strong>{" "}
                    over Large Language Model (LLM) usage across projects and
                    departments.
                  </p>
                </div>
              </div>
              <Benefits />
              {/* Features Cards */}
              {/* {[
    { icon: "📊", title: "Real-Time Monitoring", description: "Track LLM usage and costs in real time." },
    { icon: "💰", title: "Cost Attribution & Budget Control", description: "Allocate expenses per project, team, or department." },
    { icon: "🔍", title: "Logs & Transparency", description: "Centralized tracking of LLM interactions." },
    { icon: "⚙️", title: "Containerized Microservices", description: "Ensuring modularity, scalability, and efficiency." },
    { icon: "💬", title: "Single Chat Window", description: "Unified interface for querying multiple LLMs." },
    { icon: "🔒", title: "Active Directory Integration", description: "Granular permission control for users." }
  ].map((feature, index) => (
    <div key={index} className="col-md-4">
      <div className="card feature-card">
        <div className="card-body d-flex align-items-center">
          <div>
            <h5 className="feature-title">{feature.icon} {feature.title}</h5>
            <p className="feature-description">{feature.description}</p>
          </div>
        </div>
      </div>
    </div>
  ))} */}
              <div className="col-12">
                {features.map((image, index) => (
                  <div
                    key={index}
                    className="col-12 col-sm-12 col-md-12 col-lg-12"
                  >
                    <div className="card feature-card">
                      <img
                        src={image}
                        alt={`Feature ${index + 1}`}
                        className="feature-image"
                      />
                    </div>
                  </div>
                ))}
              </div>

              <QuickLinks />

              {/* Problem-Solution Card */}
              <div className="col-12">
                <div className="card llm-card">
                  <h4 className="subheading">
                    🚀 How LLMInsights Solves Key Challenges:
                  </h4>
                  <p className="card-text">
                    <strong>Problem:</strong> Difficulty in tracking and
                    managing LLM expenses, lack of real-time monitoring, and
                    challenges in attributing costs to specific teams.
                    <br />
                    <strong>Solution:</strong> LLMInsights centralizes
                    governance, provides structured cost allocation, and enables
                    AI-driven operational efficiency.
                  </p>
                  <h4 className="subheading">🌐 Explore More:</h4>
                  <p className="card-text">
                    Visit our platform:
                    <a
                      href="https://llminsight.ai"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      LLMInsights
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
              <div className="card div-style">
                <img src={LLMInsightLogo} alt="AI" className="img-style" />
                <div className="card-body">
                  <h5 className="href-h5">
                    <a href="llminsight" title="LLMInsight" className="a-line">
                      LLM Insight
                    </a>
                  </h5>
                  <ul className="list-unstyled">
                    <li>LLMInsight</li>
                  </ul>
                  <h6>
                    <a href="llminsight" title="LLM Insight" className="a-line">
                      Tell Me More
                    </a>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
              <div className="card div-style">
                <img src={serviceAI} alt="AI" className="img-style" />
                <div className="card-body">
                  <h5 className="href-h5">
                    <a href="genai" title="Gen AI" className="a-line">
                      Gen AI
                    </a>
                  </h5>
                  <p style={{ fontSize: 15 }}>
                    LLMInsight | Automatication | OpenAI | sAzureAI
                  </p>
                  {/* <ul className="list-unstyled">
                    <li>LLMInsight</li>
                    <li>Automatication</li>
                    <li>OpenAI</li>
                    <li>AzureAI</li>
                  </ul> */}
                  <h6>
                    <a href="genai" title="Manage Cloud" className="a-line">
                      Tell Me More
                    </a>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
              <div className="card div-style">
                <img src={serviceimage2} alt="blub" className="img-style" />
                <div className="card-body">
                  <h5 className="href-h5">
                    <a href="migrations" title="Migration" className="a-line">
                      MIGRATIONS
                    </a>
                  </h5>
                  <p style={{ fontSize: 14 }}>
                    Infrastructure Management | Certified Expert Support |
                    Customized Solutions | Reports & Monitoring
                  </p>
                  {/* <ul className="list-unstyled">
                    <li> Infrastructure Management</li>
                    <li>Certified Expert Support</li>
                    <li>Customized Solutions</li>
                    <li>Reports & Monitoring</li>
                  </ul> */}
                  <h6>
                    <a
                      href="migrations"
                      title="Manage Cloud"
                      className="a-line"
                    >
                      Tell Me More
                    </a>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
              <div className="card div-style">
                <img
                  src={serviceimage1}
                  alt="3 people images"
                  className="img-style"
                />
                <div className="card-body">
                  <h5 className="href-h5">
                    <a
                      href="manageCloud"
                      title="MANAGE CLOUD"
                      className="a-line"
                    >
                      MANAGE CLOUD
                    </a>
                  </h5>
                  <p style={{ fontSize: 14 }}>
                    Environment Migration | Automation Tools | Migration &
                    Launch | Train & Document
                  </p>
                  {/* <ul className="list-unstyled">
                    <li>Environment Migration</li>
                    <li>Automation Tools</li>
                    <li>Migration & Launch</li>
                    <li>Train & Document</li>
                  </ul> */}
                  <h6>
                    <a
                      href="manageCloud"
                      title="Manage Cloud"
                      className="a-line"
                    >
                      Tell Me More
                    </a>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
              <div className="card div-style">
                <img
                  src={serviceimage5}
                  alt="blub2"
                  className="img-style"
                ></img>
                <div className="card-body">
                  <h5 className="href-h5">
                    <a href="AboutUs" title="About Us" className="a-line">
                      About Us
                    </a>
                  </h5>
                  <h6>About Us</h6>
                  <h6>
                    <a href="AboutUs" title="Manage Cloud" className="a-line">
                      Tell Me More
                    </a>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
              <div className="card div-style">
                <img
                  src={serviceimage6}
                  alt="3 people images"
                  className="img-style"
                ></img>
                <div className="card-body">
                  <h5 className="href-h5">
                    <a href="ContactUs" title="Contact us" className="a-line">
                      Contact Us
                    </a>
                  </h5>
                  <h6>Contact Us</h6>
                  <h6>
                    <a href="ContactUs" title="Manage Cloud" className="a-line">
                      Tell Me More
                    </a>
                  </h6>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="screen-reader-response">
              <p role="status" aria-live="polite" aria-atomic="true"></p>
              <ul></ul>
            </div>
          </div>
        </div>
      </div>
      <ContactForm />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          justifySelf: "center",
          padding: 20,
        }}
      >
        <h4 className="qr_text">Scan QR Code to download LLM Insight Deck</h4>
        <img
          src="/qr_code.png"
          style={{
            height: "30%",
            width: "30%",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
            border: "1px solid rgba(0, 0, 0, 0.3)",
            borderRadius: 10,
            justifySelf: "center",
            marginTop: 10,
          }}
        />
      </div>
    </>
  );
};

export default Home;
